import {Box, Button, Link, Typography} from "@mui/material";
import FileIcon from "pages/Material/view/components/FileItem/FileIcon";
import DownloadIcon from "assets/icons/Download";

interface FileItemProps {
  name?: string | null;
  file: {
    name: string;
    url: string;
  };
  padding?: number;
  backgroundColor?: string;
}

const FileItem = ({name, file, padding = 2.5, backgroundColor = 'grey.400'}: FileItemProps) => {
  return (
    <Box sx={(theme) => ({
      p: padding,
      borderRadius: 4,
      backgroundColor,
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'center',
      },

    })}>

      <FileIcon fileName={file.name}/>
      <Typography sx={(theme) => ({
        ...theme.typography.h6,
        mb: 2,
        [theme.breakpoints.up('md')]: {
          mb: 0,
          flex: 1,
          mr: 4
        }
      })}>
        {name || file.name}
      </Typography>
      <Button
        component={Link}
        href={file.url}
        target="_blank"
        sx={{
          color: 'primary.main',
          fontSize: 14,
          fontWright: 500,
          lineHeight: '120%',
          fontFamily: '"Pragmatica Extended", Arial, sans-serif',
          py: 1.2,
          '& .MuiButton-icon': {
            mr: 1.5
          }
        }}
        startIcon={<DownloadIcon/>}>
        Скачать
      </Button>
    </Box>
  )
}

export default FileItem
